// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { ConfluenceCard } from './ConfluenceCard';
export { ConfluenceLinksCard } from './ConfluenceLinksCard';

const confluenceCard = EntityCardBlueprint.make({
  name: 'confluence',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { ConfluenceCard } = await import('./ConfluenceCard');
      return <ConfluenceCard />;
    },
  },
});

const confluenceLinksCard = EntityCardBlueprint.make({
  name: 'confluence-links',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { ConfluenceLinksCard } = await import('./ConfluenceLinksCard');
      return <ConfluenceLinksCard />;
    },
  },
});

export const confluenceCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [confluenceCard, confluenceLinksCard],
});
